<ion-button *ngIf="position === 'tracker-bar'" class="bar-button" color="gray" (click)="editMatch()" expand="block" fill="clear">
    <div>
        <ion-icon name="build"></ion-icon>
        <span>Edit</span>
    </div>
</ion-button>